import { Button, Typography } from '@growdash/design-system/atoms';
import { cn } from '@growdash/design-system/utils/helpers.js';

type ITabValue = 'overview' | 'menu' | 'branches';
type Props = {
  onTabChange: (val: ITabValue) => any;
  activeTab: ITabValue;
};
const tabOptions: {
  label: string;
  value: ITabValue;
}[] = [
  {
    label: 'Overview',
    value: 'overview',
  },
  {
    label: 'Menu',
    value: 'menu',
  },
  {
    label: 'Branches',
    value: 'branches',
  },
];

export default function BrandPageTabs({ onTabChange, activeTab }: Props) {
  return (
    <div className="mt-1.5 border-b-[2px] border-b-tertiary">
      <div className="flex items-center">
        {tabOptions.map((opt) => {
          const isActive = opt.value == activeTab;
          return (
            <Button
              variant="outline"
              onClick={() => {
                onTabChange(opt.value);
              }}
              className={cn(
                'border-b-[2px] hover:bg-tertiary border-t-0 border-l-0 border-r-0 lg:w-[8.75rem]  translate-y-0.5 rounded-b-none rounded-t-sm ',
                {
                  '!border-b-text_primary text-primary': isActive,
                  '!border-b-tertiary  ': !isActive,
                },
              )}
            >
              <Typography
                className={cn(
                  '"text-sm transition-all duration-100 text-tertiary"',
                  {
                    'text-primary font-bold': isActive,
                    'text-tertiary': !isActive,
                  },
                )}
              >
                {opt.label}
              </Typography>
            </Button>
          );
        })}
      </div>
    </div>
  );
}
